import { Components } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Link(): Components {
  return {
    MuiLink: {
      defaultProps: {
        underline: 'hover'
      },

      styleOverrides: {
        root: {}
      }
    }
  };
}
